var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ListElement } from "./listelement.styles";
import { ListItem } from "./listitem.styles";
/**
 * Render HTMLList as ordered or unordered lists
 * @param ordered - render List as ordered or unordered type
 * @param level - define level of list nesting
 * @param children - child components as List.Item
 * @param listItemMarginLeft - margin left
 * @param listItemMarginTop - margin top
 * @param fontSize - font-size
 * @constructor
 */
export function List(_a) {
    var { ordered = false, level = "1", children, listItemMarginLeft = 8, listItemMarginTop = 8, fontSize = "p2", previewIdExtractor } = _a, restProps = __rest(_a, ["ordered", "level", "children", "listItemMarginLeft", "listItemMarginTop", "fontSize", "previewIdExtractor"]);
    // get all children of type List.Item and pass ListProps to them
    const listItems = React.Children.map(children, (child, index) => React.isValidElement(child) && child.type === List.Item
        ? React.cloneElement(child, {
            fontSize,
            "data-preview-id": typeof previewIdExtractor === "function"
                ? previewIdExtractor(child, index)
                : undefined,
            level,
            ordered,
            listItemMarginLeft,
            listItemMarginTop,
        })
        : undefined).filter(Boolean);
    return (_jsx(ListElement, Object.assign({}, restProps, { role: "listitem", ordered: ordered, level: level, as: ordered ? "ol" : "ul" }, { children: _jsx(_Fragment, { children: listItems }) })));
}
List.Item = ListItem;
